import { render } from "./WritingPage.vue?vue&type=template&id=31d708f5&scoped=true"
const script = {}

import "./WritingPage.vue?vue&type=style&index=0&id=31d708f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d708f5"]])

export default __exports__